import { loadAssignmentUnitsEpicReducer } from "./epicsV2.js";
const getLoadAssignmentUnitsEpicReducer = () => loadAssignmentUnitsEpicReducer;
const rootEpic = loadAssignmentUnitsEpicReducer.epic;
export {
  rootEpic as default,
  getLoadAssignmentUnitsEpicReducer,
  rootEpic
};
//# sourceMappingURL=epics.js.map
